export class DestinoDomicilioCasa {
  idCliente: number;
  idPromoActivacion: string;
  pasajero: string;
  numeroContacto: string;
  kilometros: number;
  tarifa: number;
  Referencia:  string;
  txtShowMarker: boolean;
  marker: google.maps.Marker;  
  index: number;
  DIRECCION: string;
  direccionGeocode: string;
  latllng: google.maps.LatLng;
  estado: boolean;
  showReferencia: boolean;
  Instruccion:string;
  ZONA : number;
  LONGITUD : string;
  LATITUD : string

    constructor() {
        this.txtShowMarker = false;
        this.showReferencia = false;
    }
}
